export default {
  functional: true,
  render: (h: any, ctx: any) => ctx.props.vnodes
}